module.exports = __webpack_public_path__ + "img/x6.bce7e924.jpg";